import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { useApolloClient } from "@apollo/client";
import { GetVatCodesForSelectDocument, GetVatCodesForSelectQuery } from "__generated__/view/vatcodes/graphql/vatCode.queries.generated";
import { VatRelation } from "__generated__/enums";
import { ChildPropsFromArray } from "types/commons";

export type BaseVatCodeSelectOption = ChildPropsFromArray<GetVatCodesForSelectQuery, "vatCodes">;

export type VatCodeSelectOption = Omit<BaseVatCodeSelectOption, "allocation" | "percentage"> & {
	allocation?: NonNullable<BaseVatCodeSelectOption["allocation"]> | null;
	percentage?: NonNullable<BaseVatCodeSelectOption["percentage"]> | null;
};

const VatCodeSelect = <Multiple extends boolean = false,>({
	allocation,
	...rest
}: Omit<SelectProps<VatCodeSelectOption, Multiple>, "fetchOptions" | "paginated" | "getOptionLabel"> & { allocation?: VatRelation }) => {

	const client = useApolloClient();

	const onFetchOptions = async() => {

		const { data } = await client.query({
			query: GetVatCodesForSelectDocument,
		});

		const options = (data?.vatCodes ?? []).filter(it =>
			allocation ? it.allocation === allocation : true,
		);

		return {
			options,
			totalResults: options.length,
		};
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			getOptionLabel={option => option.label || ""} />
	);
};

export default VatCodeSelect;
